module.exports = __webpack_public_path__ + "static/media/console.26b97468.jpg";